import { Link } from "@tanstack/react-router";
import { Icon } from "icons";
import { useTranslation } from "react-i18next";
import { Button } from "ui";

import { SztamaLogo } from "src/components/SztamaLogo";

interface PublicNotFoundProps {
  title: string;
  description: string;
}

export function PublicNotFound(props: PublicNotFoundProps) {
  const { t } = useTranslation();

  return (
    <section
      aria-labelledby="public-not-found-title"
      className="flex min-h-screen items-center justify-center bg-gradient-to-b from-orange-50 to-white px-5 py-12"
    >
      <div className="w-full max-w-md text-center">
        <Link to="/" aria-label="Sztama" className="inline-flex text-slate-950">
          <SztamaLogo className="h-3 w-[109px]" />
        </Link>
        <div className="mx-auto mt-12 flex size-16 items-center justify-center rounded-full bg-orange-100 text-orange-700">
          <Icon name="tabler-user-question" className="size-8" />
        </div>
        <h1
          id="public-not-found-title"
          className="mt-6 text-2xl font-semibold text-slate-950"
        >
          {props.title}
        </h1>
        <p className="mt-3 text-sm leading-6 text-muted-foreground">
          {props.description}
        </p>
        <Button asChild className="mt-8 rounded-full px-6">
          <Link to="/">{t("publicProfileNotFoundAction")}</Link>
        </Button>
      </div>
    </section>
  );
}
